import { LayerProps } from 'react-map-gl/mapbox'

export const clusterLayer: LayerProps = {
  id: 'clusters',
  type: 'symbol',
  source: 'rivenditori',
  filter: ['has', 'point_count'],
  layout: {
    'icon-image': 'markerCluster',
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 16,
  },
  paint: {
    'text-color': '#FFFFFF',
  },
}

export const clusterCountLayer: LayerProps = {
  id: 'cluster-count',
  type: 'symbol',
  source: 'rivenditori',
  filter: ['has', 'point_count'],
  layout: {
    'icon-image': 'markerCluster',
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 16,
  },
  paint: {
    'text-color': '#ffffff',
  },
}

export const unclusteredPointLayer: LayerProps = {
  id: 'unclustered-point',
  type: 'symbol',
  source: 'rivenditori',
  filter: ['!', ['has', 'point_count']],
  layout: {
    'icon-image': 'pin',
  },
}

export const unclusteredPointGetIconLayer: LayerProps = {
  id: 'unclustered-point',
  type: 'symbol',
  source: 'rivenditori',
  filter: ['!', ['has', 'point_count']],
  layout: {
    'icon-image': ['get', 'icon'],
  },
}

export const rad = (x: number) => (x * Math.PI) / 180

export const roundToDecimalPlace = (number, decimalPlaces) => {
  const factor = Math.pow(10, decimalPlaces)
  return Math.round(number * factor) / factor
}

// https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula/21623206#21623206
export const getDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  const r = 6371 // km
  const p = Math.PI / 180

  const a =
    0.5 -
    Math.cos((lat2 - lat1) * p) / 2 +
    (Math.cos(lat1 * p) * Math.cos(lat2 * p) * (1 - Math.cos((lon2 - lon1) * p))) / 2

  return 2 * r * Math.asin(Math.sqrt(a))
}

export const getDistanceCoords = (lat: number, lng: number, mlat: string, mlng: string) => {
  const R = 6371
  const dLat = rad(Number.parseFloat(mlat) - lat)
  const dLong = rad(Number.parseFloat(mlng) - lng)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c

  return d
}

export const calculateDistances = (lat: number, lng: number, rivenditori: any[]) => {
  const rivenditoriDistance = rivenditori.map((rivenditore) => {
    const d = getDistanceCoords(lat, lng, rivenditore.latitudine, rivenditore.longitudine)
    return { ...rivenditori, distance: roundToDecimalPlace(d, 1) }
  })

  return rivenditoriDistance
}

export const checkValidCoords = (latitudine, longitudine) => {
  if (!isNaN(latitudine) && !isNaN(longitudine)) {
    const lat = parseFloat(latitudine)
    const lng = parseFloat(longitudine)

    return lng >= -180 && lng < 180 && lat >= -90 && lat < 90
  }

  return false
}

export const loadIcon = (map, resolve, reject, name, url) => {
  if (!map.hasImage(name)) {
    map.loadImage(url, (error, image) => {
      if (error) {
        reject(error)
      } else {
        if (!map.hasImage(name)) {
          map.addImage(name, image)
        }
        resolve()
      }
    })
  }
}
